// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__tYN5p","footer":"ModalUpdate_footer__2IMZF"};